(function () {

    'use strict';

    angular.module('Services').service(
        'AccountingSurchargeProfileSurchargesTableService',
        AccountingSurchargeProfileSurchargesTableService
    );

    AccountingSurchargeProfileSurchargesTableService.$inject = [
        'TableLiteFactory', 
        '$uibModal',
        '$filter'
    ];

    function AccountingSurchargeProfileSurchargesTableService(
        TableLiteFactory, 
        $uibModal,
        $filter
    ) {
        let surcharges = [];
        return function () {
            const fixValueType = 'FIX'; 
            const percentValueType = 'PERCENT';

            const tableData = {
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New Surcharge',
                        tooltip: 'Add New Surcharge',
                        onClick: function () {
                            openModal().then((data) => {
                                surcharges.push(data.surchargeData);
                                buildTableData({ content : surcharges });
                            });
                        }
                    }]
                },
                config: {
                    noFooter: true,
                    noFilter: true,
                    noPagination: true,
                    noSort: true,
                    noHeaders: false,
                    noItemsView: true,
                    noTableFooter: true,
                    colMinWidth: '135px'
                },
                headers: [
                    {
                        label: 'Priority',
                        viewName: 'priority',
                        width: '50px'
                    }, 
                    {
                        label: 'Surcharge Internal Name',
                        viewName: 'surchargeInternalName'
                    },
                    {
                        label: 'Service Code',
                        viewName: 'serviceCodeSurcharge'
                    },
                    {
                        label: 'Value ($ or %)',
                        viewName: 'valueStr'
                    },
                    {
                        label: 'Margin ($ or %)',
                        viewName: 'marginStr'
                    },
                    {
                        label: 'Actions',
                        viewName: 'action',
                        class: 'text-center',
                        filter: {
                            type: 'button'
                        }
                    }
                ],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: function(success) {
                    success({ content: surcharges })
                },
                callbackFormat: ['success'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    console.log(err);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                tableData.data = [];
                if (!data) {
                    return null;
                }

                surcharges = data.content;
                angular.forEach(data.content, function (surcharge) {
                    surcharge.valueStr  =  (surcharge.feeValueType == fixValueType) ? $filter('bbaCurrency')(surcharge.fee) : `${surcharge.fee} %`; 
                    surcharge.marginStr =  (surcharge.marginValueType == fixValueType) ?  $filter('bbaCurrency')(surcharge.margin) : `${surcharge.margin} %`;

                    surcharge.action = {
                        type: 'button',
                        buttons: [{
                            text: 'Edit',
                            class: 'btn btn-primary',
                            action: function () {
                                openModal(surcharge).then(data => {
                                    if(data.surchargeOriginalData) {
                                        for(let i = 0; i < tableData.data.length; i++) {
                                            const tableSurchargeData = tableData.data[i]; 
                                            if((tableSurchargeData.priority == data.surchargeData.priority) && (tableSurchargeData.surchargeInternalName != data.surchargeData.surchargeInternalName)){
                                                tableData.data[i].priority = data.surchargeOriginalData.priority; 
                                            }    
                                        }
                                    }
                                    angular.extend(surcharge, data.surchargeData);
                                    buildTableData({content: surcharges});
                                });
                            }
                        }, {
                            text: 'Delete',
                            class: 'btn btn-danger',
                            action: function () {
                                surcharges.splice(surcharges.findIndex(surchargeTemp => surchargeTemp === surcharge), 1);
                                buildTableData({ content : surcharges });
                            }
                        }]
                    };
                    tableData.data.push(surcharge);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;
            this.updateTableData = function( data ) {
                buildTableData({ content: data });
            };

            function openModal(surcharge) {
                const modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    windowClass: 'setting-modal',
                    templateUrl: '/templates/pages/accounting/surcharge-profile-surcharge-modal.html',
                    controller: 'AccountingSurchargeProfileSurchargeDetailsController',
                    controllerAs: 'vm',
                    size: 'lg',
                    appendTo: $('body'),
                    backdrop: 'static',
                    keyboard: false, 
                    resolve: {
                        selectedSurcharge: () => surcharge,
                        savedSurcharges: () => tableData.data
                    }
                });

                return modalInstance.result;
            }

        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/AccountingSurchargeProfileSurchargesTableService.js